import axios from 'axios';

const giphySearchUrl = 'https://api.giphy.com/v1/gifs/search?api_key=alxVJ8CJhAUJawRFEro9YNM9KKnEAthy';

type SearchGiphyGifsProps = {
  searchValue?: string;
  rating?: 'g' | 'pg';
  limit?: number;
};
export const searchGiphy = ({ searchValue = 'awesome', rating = 'pg', limit = 20 }: SearchGiphyGifsProps) =>
  axios.get(`${giphySearchUrl}&q=${searchValue.replace(' ', '+')}&limit=${limit}&rating=${rating}`);
